export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: '34d4dc93-afcf-482c-85eb-52195975f495',
  },
  azureAd: {
    authorityHost: 'https://login.microsoftonline.us',
    graphUrl: 'https://graph.microsoft.us',
    clientId: '954d821c-b77e-4ac3-be38-847f8b1487f2',
    tenantId: '67323f29-0c79-4786-9348-68805d4583a0',
  },
  siteUrl: 'https://diogenes.teaminc.biz',
};
